import { useEffect } from 'react'

import { useAnalytics } from '../contexts/analytics-context'

export const usePageView = (page: string) => {
  const { capturePageview } = useAnalytics()

  useEffect(() => {
    capturePageview(page)
  }, [capturePageview, page])
}
